import React from "react";


interface IframeworkAutoplayKeyboardListener {
    data: {}
}

export const frameworkAutoplayKeyboardListener: IframeworkAutoplayKeyboardListener = {
    data: {
        "COMPONENTS": []
    }

};
export const AutoplayKeyboardListenerConfigurationContext = React.createContext(
    {}
);